import { RouteObject } from "react-router-dom";
import { ErrorBoundary } from "../components/ErrorBoundary";

export const useOsadRoutes = (): RouteObject[] => [
  {
    path: "osad",
    errorElement: <ErrorBoundary />,
    lazy: () => import("../pages/osad/OSAD"),
    children: [
      {
        index: true,
        lazy: () => import("../pages/osad/queue/QueuePage"),
      },
      {
        path: "record/:proNumber",
        lazy: () => import("../pages/osad/record-detail/RecordDetailPage"),
      },
      {
        path: "intake",
        lazy: () => import("../pages/osad/intake-form/IntakeFormPanel"),
      },
    ],
  },
];
